var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tiptap-file-download",attrs:{"href":_vm.href,"target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),(_vm.meta)?_c('span',{staticClass:"meta"},[_vm._v(_vm._s(` ${_vm.meta}`))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }